import IconRefresh from 'approot/shared/icons/icon-refresh';
import { SecondaryButton } from 'approot/shared/styles/buttons/secondary-button.style';

type Props = {
  onClick: () => void;
};

const TTSStartAgainButton = ({ onClick }: Props) => {
  return (
    <SecondaryButton
      type="button"
      $withIcon
      $borderRadius={40}
      data-tts="true"
      onClick={onClick}
    >
      <IconRefresh width={20} height={20} />
      <span>Start Again</span>
    </SecondaryButton>
  );
};

export default TTSStartAgainButton;
